module.exports = __webpack_public_path__ + "static/media/strategic-partnerships.5b7ac813.svg";